import { T } from 'consts/translationKeys'
import { IFlatTabDataWithText } from 'common-components/FlatTabbar/interfaces'
import { translate } from 'utils/translations'
import { TAspectRatio } from 'store/types/aiImage'

export const AI_GENERATE_TAB_KEY = 'generate_tab_key'
export const AI_HISTORY_TAB_KEY = 'history_tab_key'

export const AI_IMAGE_TABS_DATA: IFlatTabDataWithText[] = [
  {
    name: AI_GENERATE_TAB_KEY,
    text: translate(T.GENERATE_LABEL)
  },
  {
    name: AI_HISTORY_TAB_KEY,
    text: translate(T.VERSION_HISTORY_LABEL)
  }
]

export const HISTORY_FETCH_LIMIT = 30

export type TAspectRatioOrientation = 'landscape' | 'portrait'

export const ASPECT_RATIO_PER_TYPE: Record<
  TAspectRatioOrientation,
  TAspectRatio
> = {
  landscape: '16:9',
  portrait: '9:16'
}

export const ORIENTATION_BY_ASPECT_RATIO: Record<
  TAspectRatio,
  TAspectRatioOrientation
> = {
  [ASPECT_RATIO_PER_TYPE.landscape]: 'landscape',
  [ASPECT_RATIO_PER_TYPE.portrait]: 'portrait'
}

export const DEFAULT_STYLE_NAME = 'Default'
